export enum Status {
	OPEN = "open",
	PENDING = "pending",
	IGNORED = "ignored",
	REPAIRED = "repaired",
}

export enum ResolutionType {
	ADJUSTED = "adjusted",
	CLEANED = "cleaned",
	REBUILT = "rebuilt",
	REPAIRED = "repaired",
	REPLACED = "replaced",
	SERVICED = "serviced",
	OTHER = "other",
}

export enum Action {
	CERTIFIED = "certified",
	REJECTED = "rejected",
}

export enum AssetCategory {
	CORE = "core",
	USER = "user",
}

export enum MediaType {
	PNG = "png",
	JPEG = "jpeg",
}

export class Division {
	divisionId: string;
	divisionName: string;
	divisionType: string;
}

export class EvirDivision {
	divisionId: string;
	divisionName: string;
	divisionType: string;
	active: boolean;
	parentDivision?: Partial<{ name: string; id: string; type: string }>;
}

export enum InspectionDetailDataType {
	BOOL = "bool",
	FLOAT = "float",
	INT = "int",
	PHOTO = "photo",
	SELECT = "select",
	TAG = "tag",
	TEXT = "text",
}

export enum InspectionDetailCategory {
	ENGINE_HOURS = "engineHours",
	FUEL_VOLUME = "fuelVolume",
	ODOMETER = "odometer",
	OTHER = "other",
	PHOTO = "photo",
	WEIGHT = "weight",
}

export enum InspectionDetailMeasurementType {
	AREA = "area",
	CURRENCY = "currency",
	DISTANCE = "distance",
	FLUID_CONSUMPTION = "fluidConsumption",
	FLUID_VOLUME = "fluidVolume",
	MASS = "mass",
	PRESSURE = "pressure",
	TEMPERATURE = "temperature",
	TIME = "time",
	VELOCITY = "velocity",
	VOLUME = "volume",
}

export class Telemetry {
	timestamp: string;
	elevation?: number;
	gpTimestamp?: string;
	horizontalAccuracy?: number;
	latitude?: number;
	longitude?: number;
	verticalAccuracy?: number;
}

export enum VerificationType {
	UNVERIFIED = "unverified",
	NFC = "nfc",
	RFID = "rfid",
	PHOTO = "photo",
	UNINSPECTED = "uninspected",
	NOT_INCLUDED = "notIncluded",
	LEGACY_VERIFIED = "legacyVerified",
}

export class SignedUrl {
	signedUrl: string;
}
